import { PropsWithChildren, useEffect, useState } from 'react';
import { Sticky } from '@bridebook/web/app-shared/components/sticky';
import { Box } from '@bridebook/ui';
import { usePreventScrollOnStickyContent } from '@bridebook/web/lib/utils/hooks/use-prevent-scroll-on-sticky-content';
import componentStyles from './sticky-brochure-request.style';
import { cn } from '@bridebook/aura';

interface IProps extends PropsWithChildren {
  containerRef?: React.RefObject<HTMLElement>;
  isLoggedIn?: boolean;
  className?: string;
}

const COMPONENT_ID = 'request-brochure-sticky-wrapper';

const StickyBrochureRequest = ({ children, containerRef, isLoggedIn, className }: IProps) => {
  const styles = componentStyles(isLoggedIn);
  const [isActive, setIsActive] = useState(false);
  usePreventScrollOnStickyContent(COMPONENT_ID);

  // If no `containerRef` is passed, it should be always active. Otherwise it
  // starts as inactive until the container is scrolled in the other effect.
  useEffect(() => {
    setIsActive(!containerRef);
  }, [containerRef]);

  // This effect adds a handler for when the container is not the main window
  // body, for example in a modal. It achieves the same effect of not
  // displaying the element until the page was scrolled.
  useEffect(() => {
    const containerEl = containerRef?.current;
    if (!containerEl) return;

    let changed = false;
    const listener = () => {
      if (changed) return;

      if (!!containerEl.scrollTop && !isActive) {
        setIsActive(true);
        changed = true;
      } else if (!containerEl.scrollTop && isActive) {
        setIsActive(false);
        changed = true;
      }
    };

    containerEl.addEventListener('scroll', listener);

    return () => {
      containerEl.removeEventListener('scroll', listener);
    };
  }, [isActive, containerRef]);

  return (
    <Box id={COMPONENT_ID} style={styles.wrapper}>
      <Sticky
        className={cn('sticky-brochure-request', className)}
        stickyClassName={isActive ? 'sticky-brochure-request-sticky' : ''}>
        {children}
      </Sticky>
    </Box>
  );
};
export default StickyBrochureRequest;
